import {Container, Grid, Tab, Tabs} from '@mui/material';
import * as React from 'react';
import {useEffect, useMemo, useState} from 'react';
import {useAppTranslation} from '../services/i18n';
import PageHeader from '../components/layout/PageHeader';
import {JsonEventDayInfo,} from '../generated-api';
import {useAppDispatch, useAppSelector} from "../store";
import {selectAuthInfo} from "../store/selectors";
import {createOption, OptionValue} from "../model/form";
import {getApiResult} from "../helpers/api";
import {fetchEventDays} from "../store/eventDays";
import {dateToGuiAs} from "../helpers/date";
import {useParams} from "react-router-dom";
import {useNavigate} from "react-router";
import {AuthState} from "../store/auth";
import {SimpleSelectFormField} from "../components/form/SimpleSelectFormField";
import {Formik} from "formik";
import {ButtonGroupPlain} from "../components/form/ButtonGroupField";
import EventReportCatering from "../components/report/EventReportCatering";
import EventReportParking from "../components/report/EventReportParking";

const WEEK_SIZE = 7;
const EventReportsPage = () => {
    const t = useAppTranslation();
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const {configuration} = useAppSelector<AuthState>(selectAuthInfo);
    const [eventId, setEventId] = useState<number>(configuration?.defaultEvent?.eventId as number);
    const [eventDays, setEventDays] = useState<JsonEventDayInfo[] | undefined>(undefined);
    const [filteredEventDays, setFilteredEventDays] = useState<JsonEventDayInfo[] | undefined>(undefined);
    const [weekNo, setWeekNo] = useState<number>(0);

    const tab = params.report || 'parking';

    const weekOptions: OptionValue[] | undefined = useMemo(() => {
        if (!eventDays || eventDays.length <= 7) {
            return undefined;
        }
        const options: OptionValue[] = [];
        for (let i = 0; i < Math.ceil(eventDays.length / WEEK_SIZE); i++) {
            const dayNos = eventDays.slice(i * WEEK_SIZE, (i + 1) * WEEK_SIZE).map(d => dateToGuiAs(d.dayDate, 'd.M.'));
            if (!dayNos) {
                return;
            }
            options.push(createOption(i, 'Dny ' + dayNos[0] + ' - ' + dayNos[dayNos.length - 1]));
        }

        return options;

    }, [eventDays]);

    useEffect(() => {
        dispatch(fetchEventDays({eventId})).then((res) => {
            setEventDays(getApiResult<JsonEventDayInfo[]>(res));
        });
    }, [eventId, dispatch]);

    useEffect(() => {
        setFilteredEventDays(weekNo === undefined
            ? eventDays
            : eventDays?.slice(weekNo * WEEK_SIZE, (weekNo + 1) * WEEK_SIZE));

    }, [weekNo, eventDays]);

    return <Container>
        <Grid container spacing={2} className={'page-content page-tabs'}>
            <Grid item sm={2}>
                <PageHeader title={t('Reporty')}/>
            </Grid>
            <Grid item sm={tab === 'catering' && !!weekOptions ? 4 : 8}>
                <Tabs
                    value={tab}
                    onChange={(_, v) => navigate('/reports/' + v)}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab key={0} value={'parking'} label={t('Parkování')}/>
                    <Tab key={1} value={'catering'} label={t('Catering')}/>
                </Tabs>
            </Grid>
            {tab === 'catering' && !!weekOptions && <Grid item sm={4} sx={{display: 'flex', justifyContent: 'center', placeItems: 'center'}}>
                <ButtonGroupPlain currentValue={weekNo} options={weekOptions} name={'eventDay'} onChange={(weekNo) => {
                    if (weekNo !== undefined) {
                        setWeekNo(weekNo);
                    }
                }}/>
            </Grid>}
            <Grid item sm={2} sx={{display: 'flex', alignItems: 'center', placeItems: 'center'}}>
                <Formik
                    initialValues={{
                        eventId,
                    }}
                    onSubmit={(values) => {
                        setEventId(values.eventId);
                    }}>
                    {(props) => (
                        <form onSubmit={props.handleSubmit} style={{width: '100%'}}>
                            <div className={'form-container'}>
                                <SimpleSelectFormField name="eventId" placeholder={'Událost'} onChange={props.handleSubmit}
                                    codebookProps={{codebookName: 'event', asNumber: true, sortByKeys: true, reversed: true}}/>
                            </div>
                        </form>
                    )}
                </Formik>
            </Grid>
            {<Grid item sm={12}>
                {tab === 'parking' && eventDays && <EventReportParking eventId={eventId} eventDays={eventDays}/>}
                {tab === 'catering' && !!filteredEventDays && <EventReportCatering eventId={eventId} eventDays={filteredEventDays}/>}
            </Grid>}
        </Grid>
    </Container>;
}

export default EventReportsPage;
